angular.module("app").controller('BannersPageController', [
    '$scope',
    function ($scope) {

    }
]);